import { ProfitAnalysisPage } from "../../_shared/ProfitAnalysisPage";

export default function SpecCreatePage() {
  return <ProfitAnalysisPage paType="spec" mode="create" />;
}
